<template>
  <div class="codescreen">
    <div class="wrapper-section">
      <div class="codescreen__inner">
        <h2 class="codescreen__title pform__title pform__title_smspace">На Ваш номер отправлен&nbsp;код</h2>
        <p class="pform__subtitle codescreen__subtitle">Код отправлен на номер <b class="nowrap">{{ form.applicant.tel }}</b></p>
        <p class="codescreen__text" :class="{ 'codescreen__text_hidden': tries > 2 }">Если Ваш номер указан не верно, то Вы можете
          <a @click.prevent="tries < 3 ? showPopup = true : false">изменить</a>
          его
        </p>
        <NumberInput :forceError="(IsCodeChecked && !IsCodeCorrect) ? 'Неверный код' : ''" :filled="(v) => v.length == 4" mask="####" v-model="code" text="Введите код из SMS" name="code" />
        <div class="codescreen__timertext">
          <p v-if="codeSeconds">Повторная отправка доступна через <b>{{ timerstring }}</b></p>
          <a v-else class="codescreen__timertext-link" @click="$store.dispatch('sendCode')" :disabled="codeSeconds">Запросить повторно</a>
        </div>
        <Btn class="codescreen__button" @click="checkCode" :disabled="code.length != 4">Далее</Btn>
      </div>
    </div>
  </div>
  <Popup v-model="showPopup">
    <h3 class="pfpopup__title">Введите номер мобильного&nbsp;телефона</h3>
    <NumberInput mask="+7 (###) ###-##-##" @setError="telError = $event" :filled="(v) => v.length == 18" v-model="tel" text="Номер мобильного телефона" name="applicant-tel-change" />
    <Btn @click="changeApplicantTel" class="pfpopup__btn" :disabled="telError || !tel || !changeTelCondition">
      <span v-if="changeTelCondition">Подтвердить</span>
      <span v-else>Ожидайте {{ timerstring }}</span>
    </Btn>
  </Popup>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Popup from '@/components/Popup.vue';
import NumberInput from './inputs/NumberInput.vue';
import Btn from './Btn.vue';
export default {
  data: () => ({
    tries: 0,
    code: '',
    IsCodeCorrect: false,
    IsCodeChecked: false,
    showPopup: false,
    errorCount: 0,
    tel: '',
    telError: '',
  }),
  computed: {
    ...mapGetters(['timerstring']),
    ...mapState(['form', 'codeSeconds']),
    changeTelCondition() {
      if (!this.tries) return true
      if (this.tries > 2) return false
      return this.codeSeconds ? false : true
    }
  },
  methods: {
    changeApplicantTel() {
      if (!this.changeTelCondition) return
      this.form.applicant.tel = this.tel
      this.showPopup = false
      this.tries++
      this.$store.dispatch('sendCode', true)
    },
    async checkCode() {
      let v = this.code
      this.IsCodeChecked = false
      this.IsCodeCorrect = false
      if (v.length < 4) return
      this.IsCodeCorrect = await this.$store.dispatch('checkCode', v)
      if (['die', null].includes(this.IsCodeCorrect)) {
        let text = 'Попробуйте повторить запрос'
        if (this.IsCodeCorrect == 'die')
          text = 'Что-то пошло не так, возникла техническая&nbsp;ошибка<br>Для решения вопроса обратитесь к менеджеру <b><a class="newred nowrap" href="tel:88007007333">8 800 700 7 333</a><b>'
        this.IsCodeCorrect = null
        return this.$store.dispatch('showErrorPopup', {
          title: 'Ошибка!',
          text: text,
          button: 'Повторить',
          action: () => this.checkCode()
        })
      }
      this.IsCodeChecked = true
      if (this.IsCodeCorrect)
        this.$store.dispatch('sendAndFinish')
      else
        this.errorCount++

      if (this.errorCount == 5) {
        this.errorCount = 0
        this.$store.dispatch('showErrorPopup', {
          title: 'Запросите новый код',
          text: 'Предыдущий код подтверждения более не активен, запросите новый код',
          button: 'Ок'
        })
      }
    }
  },
  watch: {
    code(v, old) {
      if (v != old) {
        this.IsCodeChecked = false
        this.IsCodeCorrect = false
      }
    }
  },
  components: { Popup, NumberInput, Btn }
}
</script>

<style lang="sass" scoped>
.codescreen
  &__inner
    width: 604px
    max-width: 100%
    margin: 100px auto 0
  &__text
    font-size: 14px
    line-height: 1.12
    text-align: center
    margin-bottom: 64px
    transition: opacity .3s ease-out
    &_hidden
      opacity: 0
      pointer-events: none
    a
      cursor: pointer
      color: colors.$newred
  &__timertext
    text-align: center
    margin-bottom: 32px
    min-height: 53px
    &-link
      text-decoration: underline
      color: colors.$newred
      cursor: pointer
      text-underline-offset: 3px
  &__button
    width: 328px
    max-width: 100%
    margin: 32px auto
  @include for-mob
    & &__subtitle
      font-size: 20px
    &__text
      width: 240px
      margin: 0 auto 32px
    &__timertext
      line-height: 1.3
</style>